import Noty from "noty";

/**
 * Helper class to show notifications
 */
class Notif {
    #OPTIONS = {
        layout: "topLeft",
        theme: "mint",
        timeout: 3000,
        progressBar: true,
        closeWith: ["click"],
    };

    /**
     *
     * @param {string} text
     * @param {string} type [alert, success, error, warning, info]
     * @param {Object | {}} options
     */
    constructor(text, type, options = {}) {
        this.#OPTIONS.text = text;
        this.#OPTIONS.type = type;

        for (const key in options) {
            if (Object.hasOwnProperty.call(options, key)) {
                this.#OPTIONS[key] = options[key];
            }
        }

        this.noty = new Noty(this.#OPTIONS);
    }

    /**
     *
     * @param {string} text
     * @param {"alert"|"success"|"error"|"warning"|"info"} type
     */
    static show(text, type) {
        const noti = new Notif(text, type);
        noti.show();
    }

    /**
     * Show the noty
     */
    show() {
        this.noty.show();
    }

    /**
     * return noty instance of object
     * @return {Noty}
     */
    getNoty() {
        return this.noty;
    }
}

export default Notif;
export { Notif };
